import { BaseDto } from './base.dto';

export class InvoicePaymentDto extends BaseDto {
  id: number;
  invoiceId: number;
  paymentAmount: number;
  paymentAmountDue?: number;
  isPaid: boolean;
  paymentLink?: string;
  customerInvoiceId?: number;
  merchantInvoiceId?: number;
  paymentDate?: Date;
  orderReference?: string;
  gatewayTxRef?: string;
  gatewayResponse?: string;
  paymentStatus?: string;
  paymentType?: string;
  authorizedAmount?: number;
  settledAmount?: number;
  success?: boolean;
  approvalCode?: string;
  data?: object;
  merchantPaymentMethodId?: number;
  redirect?: object;
  notification?: object;
  response?: object[];
  lastModifiedUserId?: number;
  bankMIDId?: number;
  stripeConnectWasUsed?: boolean;
  includedInFirebatch?: boolean;
  includedRefundInFirebatch?: boolean;
  isRefunded?: boolean;
  refundedDate?: Date;  
}
